import { combineEpics } from 'redux-observable';
import { createPageEpic } from './create-page-epic';
import { duplicatePageEpic } from './duplicate-page-epic';
import { loadPageEpic } from './load-page-epic';
import { updatePageEpic } from './update-page-epic';

export const pageEpics = combineEpics(
  createPageEpic,
  duplicatePageEpic,
  loadPageEpic,
  updatePageEpic,
);
